import React from "react";
import GridSource from "./DataGrid";
import "./scss/DataGrid.scss";
const DataGrid = props => {
    const {dataSource, gridOptions, showLoader} = props;
    return (
        <GridSource dataSource={dataSource} gridOptions={gridOptions} showLoader={showLoader}></GridSource>
    )
};

export default DataGrid;